import React from "react";
import { Field } from "react-final-form";
import { isRequired } from "@lib/validations";

import Textarea from "@components/Form/Textarea";

const TextareaInput = (props) => {
  if (props.valid) {
    return (
      <Field
        id={props.name}
        name={props.name}
        label={props.label}
        component={Textarea}
        type="text"
        required={props.required}
        validate={
          props.required
            ? isRequired()
            : () => {
                return undefined;
              }
        }
      />
    );
  }

  // Invalid component
  return null;
};

export default TextareaInput;
